import React, { useCallback } from 'react'
import { LocationAttachmentsListItem } from './LocationAttachmentsListItem'
import Box from '@mui/material/Box'
import { Scrollbar } from '@workwave-tidal/core/components'
import { IDocumentModel } from '@user/store/locationDocuments'
import { IAttachmentToAgreementDTO } from '@user/store/attachments'
import {
  setSelectedAttachments,
  useSelectedAttachmentStore,
} from '../selectedAttachmentStore'

type Props = {
  dataList: IDocumentModel[]
}

export function LocationAttachmentsList({ dataList }: Props) {
  const { isSelectionEnable, selectedAttachments } =
    useSelectedAttachmentStore()

  const handleCheckChange = useCallback(
    (attachment: IDocumentModel) => {
      const tempSelectedAttachments = [...selectedAttachments]
      const existIndex = tempSelectedAttachments?.findIndex(
        (row) => row?.id == attachment.documentId,
      )
      const mappedAttachment: IAttachmentToAgreementDTO = {
        attachmentType: attachment.documentType,
        createdDate: attachment.date,
        displayName: attachment.fileName,
        fileSize: '',
        id: attachment.documentId,
        isSaleCenterAttachment: false,
        isCompletedFormPdf: attachment.isCompletedFormPdf,
      }
      if (existIndex == -1) {
        tempSelectedAttachments.push(mappedAttachment)
        setSelectedAttachments(tempSelectedAttachments)
        return
      }
      tempSelectedAttachments.splice(existIndex, 1)
      setSelectedAttachments(tempSelectedAttachments)
    },
    [selectedAttachments],
  )

  return (
    <Box
      sx={{
        height: isSelectionEnable
          ? 'calc(100vh - 345px)'
          : 'calc(100vh - 310px)',
      }}
    >
      <Scrollbar>
        <Box px={2}>
          {dataList
            ?.sort(
              (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime(),
            )
            .map((attachment) => {
              const selected = selectedAttachments?.find(
                (row) => row?.id == attachment.documentId,
              )
              return (
                <LocationAttachmentsListItem
                  key={attachment.documentId}
                  attachment={attachment}
                  isSelectionEnable={isSelectionEnable}
                  checked={!!selected}
                  handleCheckChange={() => handleCheckChange(attachment)}
                />
              )
            })}
        </Box>
      </Scrollbar>
    </Box>
  )
}
